var React = require('react');

function IconEmail (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(93.408 -1420) rotate(90)"},[React.createElement("path",{"d":"M4,1A3,3,0,0,0,1,4V25.408a3,3,0,0,0,3,3H19.024a3,3,0,0,0,3-3V4a3,3,0,0,0-3-3H4M4,0H19.024a4,4,0,0,1,4,4V25.408a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z","transform":"translate(1420 64)","fill":"#dab26f","key":0}),React.createElement("path",{"d":"M1423.453,88.091l-.746-.666,8.671-9.7-8.049-9.668.769-.64,8.6,10.331Z","transform":"translate(1.574 1.065)","fill":"#dab26f","key":1}),React.createElement("path",{"d":"M5.6,8.3l-6-8L.4-.3l6,8Z","transform":"translate(1432.012 80.704)","fill":"#dab26f","key":2}),React.createElement("path",{"d":"M.4,8.3l-.8-.6,6-8,.8.6Z","transform":"translate(1432.012 68.704)","fill":"#dab26f","key":3})]));
}

IconEmail.defaultProps = {"width":"29.408","height":"23.024","viewBox":"0 0 29.408 23.024"};

module.exports = IconEmail;

IconEmail.default = IconEmail;
